import React, { useEffect } from "react";
import jsPDF from "jspdf";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import { Grid, Box, TextField, Autocomplete, Checkbox, IconButton } from "@mui/material";
import { BASE_URL } from "./../../global";
import ExcelDownload from "../../utils/components/excelDownload";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ListWrap from "../commonComponent/listWrap";

let notNeededColumn = ["id"];

const headers = [
  { key: "companyName", label: "Client" },
  { key: "serviceReqNumber", label: "SRF No." },
  { key: "Total_Instrument", label: "Total Instrument" },
  { key: "Calibrated", label: "Calibrated" },
  { key: "Approved", label: "Approved" },
  { key: "Pending", label: "Pending" },
  { key: "invoiceStatus", label: "Invoice Status" },
];
export default function ProgressReport() {
  const [page, setPage] = React.useState(0);
  const [srfNo, setSrfNo] = React.useState(0);
  const [searchSRNO, setsearchSRNO] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [statusData, setStatusData] = React.useState([]);
  const [instrumentQuantity, setinstrumentQuantity] = React.useState([]);
  const [selectedSRFNo, setSelectedSRFNo] = React.useState([]);
  const [fromDate, setFromDate] = React.useState("");
  const [toDate, setToDate] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const printComponentRef = React.useRef();
  const [searched, setSearched] = React.useState(false);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const _companyHierarchy = localStorage.getItem("companyHierarchy");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getSRFNOList = (event) => {
    let url = BASE_URL;
    let whereClause = `WHERE status = 1`;
    if (fromDate && toDate) {
      whereClause += ` AND DATE(entryDate) BETWEEN '${fromDate}' AND '${toDate}'`;
    }
    if (_userType == 3) {
      whereClause += ` AND clientId = '${_clientId}'`;
    }
    if (_userType == 3 && _companyHierarchy && _companyHierarchy !== "null") {
      const arr = _companyHierarchy.split(",");
      const mid = Math.floor(arr.length / 2);

      if (arr.length >= 2 && arr.length % 2 === 0) {
        const pairs = arr.slice(0, mid).map((prefix, i) => {
          const suffix = arr[mid + i];
          return `(companyHierarchy = '${prefix},${suffix}')`;
        });

        if (pairs?.length) {
          whereClause += ` AND ${pairs.join(" OR ")}`;
        }
      }
    }
    const sqlQuery = {
      query: `SELECT * FROM srfs ${whereClause} ORDER BY id DESC`,
    };

    axiosWithToken
      .post(url + `dynamic`, sqlQuery)
      .then((res) => {
        setSrfNo(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  var pushArray = [];

  for (let i = 0; i < srfNo.length; i++) {
    pushArray.push({
      id: srfNo[i].id,
      label: srfNo[i].serviceReqNumber,
    });
  }

  const getData = (event) => {
    let url = BASE_URL;
    const query = {
      query: `SELECT cv.companyName, cv.serviceReqNumber AS serviceReqNumber, COUNT(*) AS Total_Instrument, COUNT(CASE WHEN cv.calibratedby IS NOT NULL THEN 1 END) AS Calibrated, COUNT(CASE WHEN cv.approvedby IS NOT NULL THEN 1 END) AS Approved, COUNT(CASE WHEN cv.calibratedby IS NULL THEN 1 END) AS Pending, CASE WHEN ci.serviceReqNumber IS NOT NULL THEN 'Yes' ELSE 'No' END AS invoiceStatus FROM certificatesView cv  LEFT JOIN customInvoice ci ON ci.serviceReqNumber LIKE CONCAT('%', cv.serviceReqNumber, '%') WHERE cv.status != -1 and cv.serviceReqNumber IN (${searchSRNO
        .map((srno) => `'${srno}'`)
        .join(
          ","
        )}) GROUP BY cv.companyName, cv.serviceReqNumber, invoiceStatus;`,
    };


    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const findStatusBysrfNumber = (event) => {
    let url = BASE_URL;
   const query = { query: `SELECT c.companyName as Client_Name, s.serviceReqNumber as SRF_Number, s.dcNumber as dcNumber, DATE_FORMAT(s.committedDeliveryDate, '%d-%m-%Y') as CommittedDeliveryDate, cert.ULRNo as ULRNo, cert.certificateNumber as CertificateNumber, CASE WHEN si.requestedDucName IS NOT NULL AND si.requestedDucName != '' THEN si.requestedDucName ELSE i.instrumentName END as Instrument_Name, si.DUCID, si.serialNumber as Serial_ID, CASE WHEN si.location = 1 THEN 'In House' WHEN si.location = 2 THEN 'Onsite' WHEN si.location = 3 THEN 'Lab' ELSE NULL END AS Location,CASE WHEN sa.progressPercent >= 25 THEN 'Yes' ELSE 'No' END AS Inward_Status, CASE WHEN sa.progressPercent >= 50 THEN 'Yes' ELSE 'No' END AS Datasheet_Status,u.userName AS Calibrated_By, DATE_FORMAT(cert.calibrationDate, '%d-%m-%Y') as Calibration_Date, CASE WHEN sa.progressPercent >= 75 THEN 'Yes' ELSE 'No' END AS Certificate_Status,u2.userName AS Approved_By, DATE_FORMAT(cert.dateOfIssue, '%d-%m-%Y') as Date_Of_Issue, CASE WHEN FIND_IN_SET(si.id, (SELECT GROUP_CONCAT(d2.instrumentIds) FROM dispatch d2 WHERE d2.srfsId = s.id AND d2.status = 1)) THEN DATE_FORMAT(dispatch.dispatchDate, '%d-%m-%Y') ELSE NULL END AS DUC_Dispatch_Date, dispatch.dispatchMedium AS Dispatch_Medium, CASE WHEN FIND_IN_SET(si.id, (SELECT GROUP_CONCAT(d3.ducCertificateDispatch) FROM dispatch d3 WHERE d3.srfsId = s.id AND d3.status = 1)) THEN DATE_FORMAT(dispatch.certificateDispatchDate, '%d-%m-%Y') ELSE NULL END AS Certificate_Dispatch_Date FROM srfs s LEFT JOIN clients c ON s.clientId = c.id LEFT JOIN srfInstruments si ON s.id = si.srfsId LEFT JOIN instruments i ON si.instrumentId = i.id LEFT JOIN srfAnalytics sa ON s.id = sa.srfId AND si.id = sa.srfInstrumentId LEFT JOIN datasheets d ON d.id = si.id LEFT JOIN users u ON d.calibratedBy = u.id LEFT JOIN certificatesView cert ON cert.id = d.id LEFT JOIN users u2 ON cert.approvedBy = u2.id LEFT JOIN dispatch dispatch ON dispatch.srfsId = s.id AND dispatch.status = 1 AND FIND_IN_SET(si.id, dispatch.instrumentIds) WHERE cert.status != -1 and s.serviceReqNumber IN (${searchSRNO?.map((srno) => `'${srno}'`)?.join(",")})` };



    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
        setStatusData(res.data);
        const transformData = (data) => {
          const result = [];  
          data.forEach(item => {
            // Find if the combination of Client_Name, SRF_Number, and Instrument_Name already exists in the result array
            const existingItem = result.find(
              (entry) => entry.Client_Name === item.Client_Name && 
                         entry.SRF_Number === item.SRF_Number && 
                         entry.Instrument_Name === item.Instrument_Name
            );
            if (existingItem) {
              // Increment quantity if the combination already exists
              existingItem.quantity += 1;
            } else {
              // Otherwise, add a new entry with quantity 1
              result.push({
                Client_Name: item.Client_Name || "",
                SRF_Number: item.SRF_Number || "",
                Instrument_Name: item.Instrument_Name || "",
                quantity: 1
              });
            }
          });
  
          return result;
        };
        // Example usage of the transform function
        const transformedData = transformData(res.data);
        setinstrumentQuantity(transformedData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const TablePaginationActions = (props) => {
      const theme = useTheme();
      const { count, page, rowsPerPage, onPageChange } = props;
  
      const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
      };
  
      const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
      };
  
      const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
      };
  
      const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
      };
  
      return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
          >
            {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="previous page"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </IconButton>
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        </Box>
      );
    };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "l",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    const pageWidth = doc.internal.pageSize.getWidth();

    // Table Columns
    const tableColumns = [
      { title: "Client Name", dataKey: "Client_Name" },
      { title: "SRF Number", dataKey: "SRF_Number" },
      { title: "DC Number", dataKey: "dcNumber" },
      { title: "Committed Delivery Date", dataKey: "CommittedDeliveryDate" },
      { title: "ULR No", dataKey: "ULRNo" },
      { title: "Certificate Number", dataKey: "CertificateNumber" },
      { title: "Instrument Name", dataKey: "Instrument_Name" },
      { title: "Location", dataKey: "Location" },
      { title: "Inward Status", dataKey: "Inward_Status" },
      { title: "Datasheet Status", dataKey: "Datasheet_Status" },
      { title: "Calibrated By", dataKey: "Calibrated_By" },
      { title: "Calibration Date", dataKey: "Calibration_Date" },
      { title: "Certificate Status", dataKey: "Certificate_Status" },
      { title: "Approved By", dataKey: "Approved_By" },
      { title: "Date of Issue", dataKey: "Date_Of_Issue" },
      { title: "Dispatch Medium", dataKey: "Dispatch_Medium" },
      { title: "DUC Dispatch Date", dataKey: "DUC_Dispatch_Date" },
      { title: "Certificate Dispatch Date", dataKey: "Certificate_Dispatch_Date" },
    ];

    // Table Rows
    const tableRows = statusData.map((row) => [
      row.Client_Name,
      row.SRF_Number,
      row.dcNumber,
      row.CommittedDeliveryDate,
      row.ULRNo,
      row.CertificateNumber,
      row.Instrument_Name,
      row.Location,
      row.Inward_Status,
      row.Datasheet_Status,
      row.Calibrated_By,
      row.Calibration_Date,
      row.Certificate_Status,
      row.Approved_By,
      row.Date_Of_Issue,
      row.Dispatch_Medium,
      row.DUC_Dispatch_Date,
      row.Certificate_Dispatch_Date,
    ]);

    // Generate the table
    doc.autoTable({
      head: [tableColumns.map((col) => col.title)],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: false,
        fontSize: 6.2,
      },
      styles: {
        fontSize: 6,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        halign: "center",
        valign: "middle",
        cellPadding: 2,
      },
      margin: { top: 40, left: 10, right: 10, bottom: 15 },
      didDrawPage: function (data) {
        const totalPages = doc.internal.getNumberOfPages();
        const currentPage = data.pageNumber;

        // Title centered at top
        doc.setFontSize(14);
        doc.setFont(undefined, "bold");
        doc.text("Progress Report", pageWidth / 2, 25, { align: "center" });

        // Page numbering top-right (e.g., "Page 1 of 10")
        const pageText = `Page ${currentPage} of ${String(totalPages).padStart(2, "0")}`;
        doc.setFontSize(8);
        doc.setFont(undefined, "normal");
        doc.text(pageText, pageWidth - 10, 28, { align: "right" });
      },
    });

    // Save file
    doc.save("Progress_Report.pdf");
  };
  const search = () => {
    setSearched(true);
    getData();
    findStatusBysrfNumber();
  };
  const clearSearch = () => {
    setSearched(false);
    setSelectedSRFNo([]);
    setFromDate("");
    setToDate("");
    setData([]);
  };

  useEffect(() => {
    getSRFNOList();
  }, [fromDate, toDate]);


  return (
    <ListWrap>
      <Grid
        container
        spacing={1}
        justifyContent={"start"}
        alignItems={"center"}
      >
        <Grid item xs={6} sm={3} md={2} lg={1.5} textAlign={"left"}>
          <TextField
            id="Start Date"
            label="Date From"
            variant="outlined"
            type="date"
            className="Listinputcss"
            required={true}
            InputLabelProps={{ shrink: true }}
            size="small"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              setSearched(false);
            }}
          />
        </Grid>

        <Grid item xs={6} sm={3} md={2} lg={1.5} textAlign={"left"}>
          <TextField
            id="Start Date"
            label="Date To"
            variant="outlined"
            type="date"
            className="Listinputcss"
            required={true}
            InputLabelProps={{ shrink: true }}
            size="small"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              setSearched(false);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4.5} textAlign={"left"}>
          <Autocomplete
            size="small"
            className="Listinputcss"
            id="combo-box-demo"
            options={[{ id: "selectAll", label: "Select All" }, ...pushArray]} // Add "Select All" option
            disableCloseOnSelect
            multiple
            limitTags={3}
            value={pushArray.filter((option) =>
              selectedSRFNo.includes(option.id)
            )}
            onChange={(event, value) => {
              const selectedIds = value.map((e) => e.id);

              if (selectedIds.includes("selectAll")) {
                // If "Select All" is selected, select all options
                if (selectedSRFNo.length === pushArray.length) {
                  // If all are selected, remove "Select All"
                  setSelectedSRFNo([]);
                  setsearchSRNO([]);
                } else {
                  // Select all options
                  setSelectedSRFNo(pushArray.map((e) => e.id));
                  setsearchSRNO(pushArray.map((e) => e.label));
                }
              } else {
                const selectedLabels = value.map((e) => e.label);
                setSelectedSRFNo(selectedIds);
                setsearchSRNO(selectedLabels);
              }
              setSearched(false);
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={
                    option.id === "selectAll"
                      ? selectedSRFNo.length === pushArray.length
                      : selectedSRFNo.includes(option.id)
                  }
                />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Select SRF No" />
            )}
          />
        </Grid>

        <Grid item xs={3} sm={3} md={3} lg={1} textAlign={"left"}>
          <Button
            variant="contained"
            size="small"
            className="Listinputcss"
            color={searched ? "error" : "primary"}
            sx={{ m: 0 }}
            onClick={() => {
              searched ? clearSearch() : search();
            }}
          >
            {searched ? <RestartAltIcon /> : <SearchIcon />}
          </Button>
        </Grid>
        {data.length > 0 && (
          <>
            <Grid item xs={4} sm={6} md={3} lg={2} textAlign={"left"}>
              <ExcelDownload
                finalData={data}
                notNeededColumn={notNeededColumn}
                headers={headers}
                secondTable={statusData}
                thirdTable={instrumentQuantity}
              />
            </Grid>
            <Grid item xs={3} sm={6} md={6} lg={1.5} textAlign={"left"}>
                <Button
                  variant="contained"
                  size="small"
                  className="Listinputcss"
                  color="primary"
                  onClick={downloadPDF}
                >
                  Download PDF
                </Button>
            </Grid>
          </>
        )}
      </Grid>

      <TableContainer>
        <div style={{ width: "100%", margin: "auto" }} ref={printComponentRef}>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            style={{ borderCollapse: "collapse", marginTop: "5px" }}
          >
            <TableBody className="single-border-table">
              <TableRow>
                <TableCell>
                  <b>Sr.No.</b>
                </TableCell>
                <TableCell>
                  <b>Client</b>
                </TableCell>
                <TableCell>
                  <b>SRF No.</b>
                </TableCell>
                <TableCell>
                  <b>Total Instrument</b>
                </TableCell>
                <TableCell>
                  <b>Calibrated</b>
                </TableCell>
                <TableCell>
                  <b>Approved</b>
                </TableCell>
                <TableCell>
                  <b>Pending</b>
                </TableCell>
                <TableCell>
                  <b>Invoice</b>
                </TableCell>
              </TableRow>
              {data?.length > 0 ? (
                data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        id="pagbreaksborder"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        style={{ pageBreakInside: "avoid" }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.companyName}</TableCell>
                        <TableCell>{row.serviceReqNumber}</TableCell>
                        <TableCell>{row.Total_Instrument}</TableCell>
                        <TableCell>{row.Calibrated}</TableCell>
                        <TableCell>{row.Approved}</TableCell>
                        <TableCell>{row.Pending}</TableCell>
                        <TableCell>{row.invoiceStatus}</TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <h6>
                      <b>Data Not Found</b>
                    </h6>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 30, 50, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
    </ListWrap>
  );
}
